var $ = jQuery.noConflict();


$(function(){

 
   
    function sgFixedFilter() {
        if (window.innerWidth <= 1024) {
            if ($('body').hasClass('filter-fixed-scrolling')) {
                $('body').removeClass('filter-fixed-scrolling');
            }
            // Always clear inline styles on mobile/tablet, even if fixed class wasn't active
            $('#main-collection-filters').css({'padding-top': '', 'min-height': ''});
            $(window).off('scroll.sgFixedFilter');
            return;
        }

        var topFDPHeader = true;
        var topFDPHeader2 = true;
    
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            var $sidebar = $('#halo-sidebar');
            var $mainCollectionFilters = $('#main-collection-filters');
            
            if ($filterElement.length) {
                var wasFixed = $('body').hasClass('filter-fixed-scrolling');
                
                // Store current min-height before resetting (to preserve it if already fixed)
                var currentMinHeight = 0;
                if (wasFixed && $mainCollectionFilters.length) {
                    currentMinHeight = parseInt($mainCollectionFilters.css('min-height'), 10) || 0;
                }
                
                // If currently fixed, temporarily un-fix to get accurate position
                // Only reset min-height if NOT already fixed (to preserve height during resize)
                if (!wasFixed && $mainCollectionFilters.length) {
                    $mainCollectionFilters.css('min-height', '');
                }

                if (wasFixed) {
                    $('body').removeClass('filter-fixed-scrolling');
                    if ($mainCollectionFilters.length) {
                        $mainCollectionFilters.css('padding-top', '');
                        // Temporarily clear for accurate measurement
                        $mainCollectionFilters.css('min-height', '');
                    }
                }
                
                // Now we can get the true document position
                window.sgFilterTop = $filterElement.offset().top;
                
                // Calculate height EXCLUDING dropdown content (.facets__display)
                // Only include the filter row/headings, not the expanded dropdown options
                var mainCollectionFiltersHeight = 0;
                if ($mainCollectionFilters.length) {
                    // Get the height of collection-filters-form without dropdown content
                    var $facetsWrapper = $mainCollectionFilters.find('.collection-filters__item.facets__wrapper');
                    if ($facetsWrapper.length) {
                        // Calculate base height: padding + filter headings row
                        var baseHeight = 0;
                        
                        // Get the filter form element
                        var $facetsForm = $mainCollectionFilters.find('collection-filters-form');
                        if ($facetsForm.length) {
                            // Temporarily hide all dropdown content to measure collapsed height
                            var $dropdowns = $facetsForm.find('.facets__display');
                            var originalDisplay = [];
                            $dropdowns.each(function(i) {
                                originalDisplay[i] = $(this).css('display');
                                $(this).css('display', 'none');
                            });
                            
                            // Now measure the collapsed height
                            baseHeight = $mainCollectionFilters.outerHeight(true);
                            
                            // Restore original display values
                            $dropdowns.each(function(i) {
                                $(this).css('display', originalDisplay[i]);
                            });
                        } else {
                            baseHeight = $mainCollectionFilters.outerHeight(true);
                        }
                        mainCollectionFiltersHeight = baseHeight;
                    } else {
                        mainCollectionFiltersHeight = $mainCollectionFilters.outerHeight(true);
                    }
                }
                
                // Re-apply fixed state if it was fixed
                // If was fixed, use the larger of old/new heights to prevent shrinking on resize
                var heightToUse = mainCollectionFiltersHeight;
                if (wasFixed && currentMinHeight > 0) {
                    heightToUse = Math.max(currentMinHeight, mainCollectionFiltersHeight);
                    console.log('[sgFixedFilter] Resize while fixed - Old:', currentMinHeight, 'New:', mainCollectionFiltersHeight, 'Using:', heightToUse);
                }
                
                if (wasFixed) {
                    $('body').addClass('filter-fixed-scrolling');
                    if ($mainCollectionFilters.length) {
                        $mainCollectionFilters.css('padding-top', heightToUse + 'px');
                    }
                }

                // Update min-height with the appropriate height
                if ($mainCollectionFilters.length) {
                    $mainCollectionFilters.css('min-height', heightToUse + 'px');
                }
                
                // Update stored height to use the final value
                mainCollectionFiltersHeight = heightToUse;
                
                var filterTop = window.sgFilterTop;
                var sidebarHeight = $sidebar.length ? $sidebar.outerHeight() : 0;

                // Check if body has b2b-custom and hide-b2b-nav classes
                const isB2bCustom = document.body.classList.contains('b2b-custom');
                const isHideB2bNav = document.body.classList.contains('hide-b2b-nav');
                const useB2bOffsets = isB2bCustom && isHideB2bNav;

                var offsetFilterHorizontal = (typeof topFDPHeader !== 'undefined' && topFDPHeader === false) ? 0 : (useB2bOffsets ? 87 : 111);

                if (topFDPHeader2) {
                    offsetFilterHorizontal += 10;
                }
                
                // Store calculated values for the scroll handler to use
                window.sgFilterData = {
                    filterTop: filterTop,
                    sidebarHeight: sidebarHeight,
                    offsetFilterHorizontal: offsetFilterHorizontal,
                    $filterElement: $filterElement,
                    $mainCollectionFilters: $mainCollectionFilters,
                    mainCollectionFiltersHeight: mainCollectionFiltersHeight
                };
                
                // Scroll handler function (extracted for reuse)
                function handleFixedFilterScroll() {
                    var scrollTop = $(window).scrollTop();
                    var data = window.sgFilterData;

                    // Check if scroll reached the element (top + offset)
                    var threshold = data.filterTop - data.offsetFilterHorizontal;

                    if (scrollTop >= threshold) {
                        if (!$('body').hasClass('filter-fixed-scrolling')) {
                            console.log('Adding fixed class. scrollTop:', scrollTop, 'Threshold:', threshold, 'filterTop:', data.filterTop);
                            // Use stored height (already calculated excluding dropdowns)
                            var currentHeight = data.mainCollectionFiltersHeight;

                            $('body').addClass('filter-fixed-scrolling');
                            if (data.$mainCollectionFilters.length) {
                                data.$mainCollectionFilters.css('padding-top', currentHeight + 'px');
                                data.$mainCollectionFilters.css('min-height', currentHeight + 'px');
                            }
                        }
                    } else if (scrollTop < (threshold - 5)) { // 5px buffer to prevent flickering
                        if ($('body').hasClass('filter-fixed-scrolling')) {
                            console.log('Removing fixed class. scrollTop:', scrollTop, 'Threshold (Remove):', (threshold - 5), 'filterTop:', data.filterTop);
                            $('body').removeClass('filter-fixed-scrolling');
                            if (data.$mainCollectionFilters.length) data.$mainCollectionFilters.css('padding-top', '');
                            // Keep min-height
                        }
                    }
                }

                // Remove previous scroll handler and add new one with updated values
                $(window).off('scroll.sgFixedFilter').on('scroll.sgFixedFilter', handleFixedFilterScroll);
                
                // FIX: Trigger immediate scroll check on page load/refresh
                // This ensures correct state when browser restores scroll position
                handleFixedFilterScroll();

                // Mutation Observer to handle height changes
                if (window.sgFilterObserver) {
                    window.sgFilterObserver.disconnect();
                }
                
                if ($mainCollectionFilters.length) {
                    window.sgFilterObserver = new MutationObserver(function() {
                        var wasFixed = $('body').hasClass('filter-fixed-scrolling');
                        
                        // Temporarily unfix to measure
                        if (wasFixed) {
                            $('body').removeClass('filter-fixed-scrolling');
                            $mainCollectionFilters.css('padding-top', '');
                        }
                        
                        // FIX: Reset min-height before measuring to avoid inflated outerHeight
                        $mainCollectionFilters.css('min-height', '');
                        
                        // Measure height EXCLUDING dropdown content (.facets__display)
                        var $facetsForm = $mainCollectionFilters.find('collection-filters-form');
                        var newHeight = 0;
                        if ($facetsForm.length) {
                            var $dropdowns = $facetsForm.find('.facets__display');
                            var originalDisplay = [];
                            $dropdowns.each(function(i) {
                                originalDisplay[i] = $(this).css('display');
                                $(this).css('display', 'none');
                            });
                            
                            newHeight = $mainCollectionFilters.outerHeight(true);
                            
                            $dropdowns.each(function(i) {
                                $(this).css('display', originalDisplay[i]);
                            });
                        } else {
                            newHeight = $mainCollectionFilters.outerHeight(true);
                        }
                        
                        var newTop = $filterElement.offset().top;
                        
                        // Re-apply fixed state
                        if (wasFixed) {
                            $('body').addClass('filter-fixed-scrolling');
                            $mainCollectionFilters.css('padding-top', newHeight + 'px');
                        }
                        
                        // Update min-height with new collapsed height
                        $mainCollectionFilters.css('min-height', newHeight + 'px');
                        
                        // Update stored data
                        if (window.sgFilterData) {
                            window.sgFilterData.mainCollectionFiltersHeight = newHeight;
                            window.sgFilterData.filterTop = newTop;
                        }
                    });
                    
                    window.sgFilterObserver.observe($mainCollectionFilters[0], {
                        childList: true,
                        subtree: true
                    });
                }
                
                // Note: No internal resize handler needed - resizeend() calls sgFixedFilter() on resize
            }
    }
    sgFixedFilter();

    function sgFixedFilterMobile() {
        if (window.innerWidth > 1024) {
            if ($('body').hasClass('filter-mobile-fixed-scrolling')) {
                $('body').removeClass('filter-mobile-fixed-scrolling');
            }
            $(window).off('scroll.sgFixedFilterMobile');
            return;
        }

        if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
            var $filterElement = $('collection-filters-form.facets.facets-horizontal.filter-display-show-more');
            
            if ($('body').hasClass('template-collection')) {
                var $toolbarElement = $('#CollectionProductGrid toolbar-item.toolbar');
            } else if ($('body').hasClass('template-search')) {
                var $toolbarElement = $('#CollectionProductGrid .toolbar-wrapper.toolbar-mobile');

                console.log("item lenght" + $toolbarElement.length)
            }

            if ($filterElement.length && $toolbarElement.length) {
                var wasFixed = $('body').hasClass('filter-mobile-fixed-scrolling');
                
                // If currently fixed, temporarily un-fix to get accurate position
                if (wasFixed) {
                    $('body').removeClass('filter-mobile-fixed-scrolling');
                }
                
                // Now we can get the true document position
                // Check if body has b2b-custom class and adjust offset accordingly
                // Offset values based on CSS toolbar positioning at different breakpoints (sg-custom-b2b.css)
                var b2bOffset;
                var isB2bCustom = document.body.classList.contains('b2b-custom');
                var isB2bLocations = document.body.classList.contains('b2b-locations');
                var isB2bNavCustom = document.body.classList.contains('b2b-nav-custom');
                var isHideB2bNav = document.body.classList.contains('hide-b2b-nav');
                var w = window.innerWidth;

                // Track which scenario is used for debugging
                var b2bScenario = '';
                
                if (isB2bCustom) {
                    // B2B users - check for specific class combinations
                    // Breakpoints: ≤500px, ≤820px, ≤900px, ≤1024px
                    if (isHideB2bNav && !isB2bLocations && !isB2bNavCustom) {
                        // hide-b2b-nav only (hidden navigation, no locations/custom nav)
                        // Based on CSS: body.b2b-custom.hide-b2b-nav padding: 136px at max-1024px
                        b2bOffset = w <= 500 ? 125 : (w <= 900 ? 140 : (w <= 1024 ? 80 : 80));
                        b2bScenario = 'B2B + hide-b2b-nav only';
                    } else if (isB2bLocations) {
                        // b2b-locations: 136px at all mobile breakpoints (from sg-custom-b2b.css)
                        b2bOffset = w <= 500 ? 136 : (w <= 820 ? 136 : (w <= 900 ? 142 : (w <= 1024 ? 80 : 80)));
                        b2bScenario = 'B2B + b2b-locations' + (isHideB2bNav ? ' + hide-b2b-nav' : '') + (isB2bNavCustom ? ' + b2b-nav-custom' : '');
                    } else if (isB2bNavCustom) {
                        // b2b-nav-custom: different values at breakpoints
                        // ≤500px: 131px, ≤820px: 131px, ≤900px: 142px, ≤1024px: 80px
                        b2bOffset = w <= 500 ? 131 : (w <= 820 ? 131 : (w <= 900 ? 142 : (w <= 1024 ? 80 : 80)));
                        b2bScenario = 'B2B + b2b-nav-custom';
                    } else {
                        // b2b-custom only (no locations, nav-custom, or hide-b2b-nav)
                        // ≤500px: 125px, ≤900px: 140px, ≤1024px: 80px
                        b2bOffset = w <= 500 ? 125 : (w <= 900 ? 140 : (w <= 1024 ? 80 : 80));
                        b2bScenario = 'B2B basic (b2b-custom only)';
                    }
                } else {
                    // Non-B2B: original logic
                    // ≤820px: 108px, ≤900px: 117px, ≤1024px: 51px
                    b2bOffset = w <= 820 ? 108 : (w <= 900 ? 117 : (w <= 1024 ? 51 : 51));
                    b2bScenario = 'Non-B2B';
                }
                
                // Debug logging for filter fixed scenario
                console.log('[sgFixedFilterMobile] Scenario:', b2bScenario, '| Width:', w, '| Offset:', b2bOffset, '| Classes:', {
                    isB2bCustom: isB2bCustom,
                    isB2bLocations: isB2bLocations,
                    isB2bNavCustom: isB2bNavCustom,
                    isHideB2bNav: isHideB2bNav
                });
                window.sgFilterTopMobile = $('#CollectionProductGrid').offset().top - b2bOffset;
                
                // Re-apply fixed state if it was fixed
                if (wasFixed) {
                    $('body').addClass('filter-mobile-fixed-scrolling');
                }
                
                var filterTop = window.sgFilterTopMobile;
                
                // Store calculated value for the scroll handler to use
                window.sgFilterDataMobile = {
                    filterTop: filterTop
                };

                // Scroll handler function (extracted for reuse)
                function handleFixedFilterMobileScroll() {
                    var scrollTop = $(window).scrollTop();
                    var data = window.sgFilterDataMobile;
                    
                    if (scrollTop >= data.filterTop) {
                        if (!$('body').hasClass('filter-mobile-fixed-scrolling')) {
                            $('body').addClass('filter-mobile-fixed-scrolling');
                        }
                    } else if (scrollTop < (data.filterTop - 7)) { // 7px buffer to prevent flickering
                        if ($('body').hasClass('filter-mobile-fixed-scrolling')) {
                            $('body').removeClass('filter-mobile-fixed-scrolling');
                        }
                    }
                }

                // Remove previous scroll handler and add new one with updated values
                $(window).off('scroll.sgFixedFilterMobile').on('scroll.sgFixedFilterMobile', handleFixedFilterMobileScroll);
                
                // FIX: Trigger immediate scroll check on page load/refresh
                // This ensures correct state when browser restores scroll position
                handleFixedFilterMobileScroll();
                
                // Note: No internal resize handler needed - resizeend() calls sgFixedFilterMobile() on resize
            }
        }
    }
    sgFixedFilterMobile();
 

    // Run Scripts after Window Resize
	/*! run scirpt after resize by Dolan Antenucci https://stackoverflow.com/users/318870/dolan-antenucci-   - https://stackoverflow.com/posts/5926068/revisions https://stackoverflow.com/questions/5489946/jquery-how-to-wait-for-the-end-of-resize-event-and-only-then-perform-an-ac/5926068#5926068 */
	var rtime;
	var timeout = false;
	var delta = 100;
	$(window).resize(function() {
		rtime = new Date();
		if (timeout === false) {
			timeout = true;
			setTimeout(resizeend, delta);
		}
	});

	function resizeend() {

	   if (new Date() - rtime < delta) {
			setTimeout(resizeend, delta);
		} else {
			timeout = false;

            sgFixedFilter();

            sgFixedFilterMobile();


		}

	} // resizeend()
    

}) // document ready
